import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from "@angular/http";

import { ProfileComponent } from './profile.component';
import { LiChessPlayerComponent } from "./li-chess-player.component";
import { LiChessService } from "./li-chess.service";

@NgModule({
  imports: [
    CommonModule,
    HttpModule
  ],
  declarations: [
    LiChessPlayerComponent,
    ProfileComponent
  ],
  providers: [
    HttpModule,
    LiChessService
  ]
})
export class ProfileModule { }



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/profile/profile.module.ts